'use strict';

bbw.WebSocket = Class({

    $q: undefined,

    url: undefined,

    /**
     * @var {WebSocket}
     */
    ws: undefined,

    _queue: [],

    _callbacks: {
        onOpen: angular.noop,
        onClose: angular.noop,
        onMessage: angular.noop,
        onError: angular.noop
    },

    construct: function($q, url) {
        this.$q = $q;
        this.url = url;
    },

    connect: function() {
        this.ws = new WebSocket(this.url);
        this.ws.onopen = this._onOpen.bind(this);
        this.ws.onclose = this._onClose.bind(this);
        this.ws.onmessage = this._onMessage.bind(this);
        this.ws.onerror = this._onError.bind(this);
        this._queue = [];

        return this;
    },

    disconnect: function() {
        if (this.isConnected()) {
           this._ws.disconnect();
        }
    },

    send: function(data) {
        if (!this.ws) {
            throw new Error('WebSocket not started');
        }
        switch (this.ws.readyState) {
            case 0:
                this._queue.push(data);
                return true;
                break;
            case 1:
                this._sendWs(data);
                return true;
                break;
            default:
                return false;
        }
    },

    _sendWs: function(data) {
        try {
            this.ws.send(data);
        } catch (e) {
            // pass
        }
    },

    onOpen: function(fn) {
        return this._setCallback('onOpen', fn);
    },

    onClose: function(fn) {
        return this._setCallback('onClose', fn);
    },

    onMessage: function(fn) {
        return this._setCallback('onMessage', fn);
    },

    onError: function(fn) {
        return this._setCallback('onError', fn);
    },

    isConnected: function() {
        return this.ws.readyState == 1;
    },

    _setCallback: function(key, fn) {
        if (!angular.isFunction(fn)) {
            fn = angular.noop;
        }
        this._callbacks[key] = fn;
        return this;
    },

    _onOpen: function(event) {
        var data;
        if (!this.isConnected()) {
            return;
        }
        while (angular.isDefined(data = this._queue.shift())) {
            if (!this.isConnected()) {
                this._queue.unshift(data);
                return;
            }
            this._sendWs(data);
        }
        this._callbacks.onOpen(event);
    },

    _onClose: function(event) {
        this._callbacks.onClose(event);
    },

    _onMessage: function(event) {
        this._callbacks.onMessage(event);
    },

    _onError: function(event) {
        this._callbacks.onError(event);
    }

});
